<div class="w-full h-full flex flex-col justify-center items-center">
	<h1 class="text-2xl">No race is live at the moment</h1>
	<img class="max-h-20 mt-10" [src]="'/assets/sro-motorsports-group.svg'" />
</div>
